<template>
    <div class="navbar">
        <IconComponent class="mobile-toggle" icon="menu" @click="toggleMobile" />

        <div class="search">

            <!-- <IconComponent class="icon" icon="search" />
            <form class="form">
                <input type="text" placeholder="Procurar" name="search" class="input">
            </form> -->
        </div>
        <div class="userdata" @click="popupVisible = true">
            <div class="logo-content" v-if="profile && profile.avatarUrl">
                <img class="logo" :src="profile.avatarUrl">
            </div>
            <div class="text">
                <p class="name">{{ currentUser.displayName }}</p>
                <p class="email">{{ currentUser.email }}</p>
            </div>
            <PopupSettings v-if="role !== 'admin'" v-show="popupVisible" @cancel="popupVisible = false" @click.stop />
        </div>
    </div>
</template>

<script>
import IconComponent from '@/components/Icons.vue'
import PopupSettings from './popups/Settings.vue';

export default {
    name: 'TopNavBar',
    components: {
        IconComponent,
        PopupSettings,
    },
    data() {
        return {
            popupVisible: false,
        };
    },
    methods: {
        toggleMobile() {
            this.$root.mobileMenu = !this.$root.mobileMenu
        },
    },

    computed: {
        currentUser() {
            return this.$store.state.users.currentUser
        },
        profile() {
            if (!this.currentUser) return null;
            return this.$store.getters['profiles/id'](this.currentUser.uid);
        },
        role() {
            return this.$store.state.users.role
        },
    },

    watch: {
        currentUser: {
            immediate: true,
            handler() {
                if (this.currentUser == null) {
                    return
                }
                this.$store.dispatch('profiles/get', this.currentUser.uid)
            },
        },
    },
}
</script>

<style lang="scss" scoped>
@import '../assets/utilities/_variables.scss';


.mobile-toggle {
    height: calc(var(--topbar-height) / 3);
    width: calc(var(--topbar-height) / 3);
    margin: 0 auto 0 0;

    @media screen and (min-width: $desktop-min-width) {
        display: none;
    }
}

.navbar {
    display: flex;

    width: 100%;
    height: var(--topbar-height);

    
    background: var(--navbar-bg-color);
    justify-content: space-between;
    align-items: center;
    border-bottom: 2px solid var(--card-border-color);
    
    z-index: 5000;
    margin: 0;
    padding: 0 2em;
    
    @media screen and (min-width: $desktop-min-width) {
        padding: 0 5em 0 2em;
        margin: 0 2rem;
    }

    .search {
        display: flex;
        border-radius: 10px;
        padding: 0 1rem;
        align-items: center;
        gap: 1rem;
        padding: .5rem 1rem;

        .icon {
            width: 20px;
            height: 20px;
            fill: rgba(var(--text-second-color), 0.8);
        }

        .form {
            .input {
                background-color: transparent;
                outline: none;
                border: transparent;
                color: var(--white);
                transition: width 0.4s ease-in-out;
            }
        }
    }

    .userdata {
        display: grid;
        grid-template-columns: 1fr;
        grid-template-rows: 1fr;
        grid-template-areas: "icon text";
        gap: 1rem;
        justify-content: center;
        align-items: center;
        cursor: pointer;

        .logo-content {
            grid-area: icon;
            height: 50px;
            width: 50px;
            object-fit: contain;
            display: inline-block;
            margin: 0;

            .logo {
                width: 100%;
                height: 100%;
                border-radius: 50%;
                border: 2px solid rgba(var(--white), 1);
                object-fit: contain;
            }
        }

        .text {
            grid-area: text;
            font-size: 12px;

            .name {
                margin: 0;
            }

            .email {
                margin: 0;
                font-size: 8px;
            }
        }
    }
}
</style>
